import * as React from "react";
import styled from "styled-components";
import { Button, Select } from "antd";

import useDevices from "@/hooks/use-device";

const Container = styled.div`
  padding: 30px 20px 0 10px;
  height: 300px;
  .cameraSelect {
    width: 280px;
    margin: 10px 0;
  }
  video {
    width: 500px;
    height: 280px;
    margin-bottom: 5px;
    background: black;
  }
`;

const NormalSetting: React.FunctionComponent = () => {
  const videoRef = React.useRef<HTMLVideoElement>();

  const [devices, setDevices] = React.useState([]);
  const [current, setCurrent] = React.useState(undefined);
  const [stream, setStream] = React.useState<MediaStream>(null);

  // const constraints = {
  //   ,
  // };

  const checkDevice = async () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { videos } = await useDevices();
    setDevices(videos);
    if (videos.length) {
      setCurrent(videos[0].deviceId);
    }
  };

  const startVideo = async () => {
    if (!current) return;
    const updatedConstraints: MediaStreamConstraints = {
      video: {
        width: 1280,
        height: 720,
        deviceId: {
          exact: current,
        },
      },
    };
    
    const astream = await navigator.mediaDevices.getUserMedia(
      updatedConstraints
    );
    setStream(astream);
    videoRef.current.srcObject = stream;
    videoRef.current.play();
  };

  React.useEffect(() => {
    checkDevice();
    return () => {
      if (videoRef.current) {
        console.log(
          "zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz"
        );
        videoRef.current.pause();
        videoRef.current!.srcObject = null;
        // stream.getVideoTracks().forEach((x) => x.stop());
        stream.getTracks().forEach((x) => x.stop());
      }
    };
  }, []);

  return (
    <>
      <Container>
        <Select
          placeholder="请选择设备"
          onChange={(v) => setCurrent(v)}
          value={current}
          className="cameraSelect"
        >
          {devices.map((d) => (
            <Select.Option value={d.deviceId} key={d.deviceId}>
              {d.label || d.deviceId}
            </Select.Option>
          ))}
        </Select>
        <div>
          <video ref={videoRef}></video>
        </div>
        <Button type="primary" onClick={startVideo}>
          测试视频
        </Button>
      </Container>
    </>
  );
};

export default NormalSetting;
